import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';

import useContext from '@/composables/useContext';
import useCategoryData from '@/composables/useCategoryData';
import { capitalize } from '@/helpers/utils';

import Breadcrumbs from '@/components/Breadcrumbs.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandBreacrumbs',
  setup(__props) {

const { settings, page, resolveLink } = useContext();
const { setBreadcrumbs } = useCategoryData();

onMounted(() => {

  const indexPageUrl = resolveLink(() => settings.value?.brandsIndex)?.url;

  const capitalizedIndexPageName = capitalize(indexPageUrl?.replaceAll('/', ''));

  const indexPage = settings.value?.brandsIndex
    ? {
      name: capitalizedIndexPageName,
      url: indexPageUrl,
      id: settings.value.brandsIndex.id,
    }
    : null;
  const currentPage = {
    name: page.value.name || '',
    url: '',
    id: page.value._id,
  };

  setBreadcrumbs(indexPage ? [indexPage, currentPage] : [currentPage]);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Breadcrumbs))
}
}

})